import { useGetEcoTaxMutation } from 'app/services/ecoTaxService/ecoTaxService';
import { formatDate } from 'common/utils/formatDate';
import { useEffect } from 'react';

type Props = {
  condition: boolean;
  invoiceDate: string;
}

export const useEcoTax = ({ condition, invoiceDate }: Props) => {
  const [getEcoTax, { isLoading, data: ecoTaxData, isSuccess, isError }] = useGetEcoTaxMutation();

  useEffect(() => {
    if (condition) {
      getEcoTax({
        businessUnitId: 'bu2-25',
        depositAndFeeRuleIds: ["abmtt20241218-01"],
        invoiceDate: formatDate(invoiceDate),
      });
    }
  }, [getEcoTax, invoiceDate, condition]);

  return { isLoading, ecoTaxData, isSuccess, isError };
}
